import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter, Link } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import {
  FaHome,
  FaChartBar,
  FaNewspaper,
  FaUsers,
  FaHistory,
  FaQuestionCircle,
  FaUserEdit,
} from "react-icons/fa";
import Select from "react-select";
import { Container, Col, Row } from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import { gethomedata } from "store/home/actions";
import axios from "axios";
import "assets/scss/table.scss";
import { method } from "lodash";
import bgImage from "../../assets/images/Participant-background-1.jpg";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      organization_name: "",
      schemes: [],
      purchased_schemes: [],
      payments: [],
      open_rounds: [],
      notifications: [], // your actual notification data
      hoveredIndex: null,
      searchTerm: "",
      report_available_rounds: [],
      // your data
      hoveredIndex: null, // for hover effect
      expandedIndex: null, // for toggling full description,
      lab_name: "", // if you want to show lab name
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : null, // ✅ Default to null instead of empty string
    };
    console.log("USER ID from localStorage:", this.state.user_id);
  }

  componentDidMount() {
    document.body.style.margin = "0";
    document.body.style.padding = "0";
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";

    const { user_id } = this.state;
    if (user_id) {
      this.props.gethomedata(user_id);
    }
  }

  componentWillUnmount() {
    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";
    document.body.style.margin = "";
    document.body.style.padding = "";
  }

  componentDidUpdate(prevProps) {
    if (prevProps.home !== this.props.home && this.props.home) {
      const {
        name,
        schemes,
        purchased_schemes,
        payment_details,
        open_rounds,
        report_available_rounds,
        news,
        participant_id, // ✅ Extract participant_id
      } = this.props.home;

      this.setState({
        schemes: schemes || [],
        purchased_schemes: purchased_schemes || [],
        payments: payment_details?.payments || [],
        open_rounds: open_rounds || [],
        report_available_rounds: report_available_rounds || [],
        notifications: news || [],
        lab_name: name || "",
        participant_id: participant_id || null, // ✅ Set it in state
      });
    }
  }

  handleEnroll = (schemeId) => {
    // Example: Save selected scheme ID, or do nothing if not needed
    console.log("Enrolling in scheme ID:", schemeId);
    // Optionally store in localStorage or Redux if needed in the Pay page
  };
  formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("default", { month: "short" });
    const year = String(date.getFullYear()).slice(-2);

    return `${day}-${month}-${year}`;
  };

  render() {
    const {
      schemes,
      purchased_schemes,
      payments,
      open_rounds,
      report_available_rounds,
      notifications,
      lab_name,
      participant_id,
    } = this.state;
    const organization_name =
      localStorage.getItem("organization_name") || "default-org";
    const participantId = Number(participant_id);

    // Map payments to scheme IDs
    const schemePaymentsMap = {};
    payments.forEach((payment) => {
      if (!payment.scheme) return;
      payment.scheme.split(",").forEach((pair) => {
        const [schemeIdStr] = pair.split("-");
        const schemeId = parseInt(schemeIdStr.trim());
        if (!schemePaymentsMap[schemeId])
          schemePaymentsMap[schemeId] = payment.paydate;
      });
    });

    // Helper to get base scheme name
    const getBaseSchemeName = (schemeName) =>
      schemeName.replace(/\(\d+[a-z]-\w+\)\s*(small|large)/i, "").trim();

    // Pending schemes
    const hasScheme29 = schemes.some((s) => s.id === 29);
    const hasScheme33 = schemes.some((s) => s.id === 33);
    const pendingSchemes = schemes.filter((scheme) => {
      const baseName = getBaseSchemeName(scheme.name);
      const isPurchased = purchased_schemes.some(
        (ps) => getBaseSchemeName(ps.scheme_name || ps.name) === baseName,
      );
      if (
        (hasScheme29 && scheme.id === 45) ||
        (hasScheme33 && scheme.id === 46)
      )
        return false;
      return !isPurchased;
    });

    // Filter report rounds for this participant
    const availableRounds = report_available_rounds.filter(
      (round) =>
        round.status === "Report Available" &&
        Number(round.participant_id) === participantId,
    );

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Home Page | NEQAS</title>
          </MetaTags>

          {/* Fixed Background */}
          <div
            style={{
              position: "fixed", // ✅ fixed background
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh", // ✅ full screen
              backgroundImage: `url(${bgImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              zIndex: -1,
              filter: "brightness(0.8)",
            }}
          />

          <Container
            fluid
            style={{
              position: "relative",
              zIndex: 1,
              padding: "0.5rem",
            }}
          >
            {/* <div
  style={{
    width: "100%",
    maxWidth: "1200px",
    minHeight: "100%",
    borderRadius: "20px",
    backgroundColor: "rgba(255, 255, 255, 0.85)",
    display: "flex",
    overflow: "hidden",
    flexDirection: "row",
    height: "calc(100% - 100px)",
  }}
> */}

            <Row className="w-100 mb-4" style={{ alignItems: "flex-start" }}>
              {/* Left: Welcome */}
              <Col md={9}>
                <div
                  style={{
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                    padding: "0.75rem 1rem",
                    borderRadius: "8px",
                    fontWeight: "bold",
                    color: "#1042adff",
                    fontSize: "1.2rem",
                    marginBottom: "1rem",
                  }}
                >
                  Welcome! {lab_name}
                </div>
                <Row className="mt-3">
                  <Col md={5}>
                    <div
                      className="p-4 bg-light shadow-lg rounded-4"
                      style={{ maxHeight: "200px" }}
                    >
                      <h5
                        className="mb-3 text-primary"
                        style={{ fontWeight: "bold" }}
                      >
                        Schemes Not Enrolled
                      </h5>

                      {/* Scroll only table rows */}
                      <div style={{ maxHeight: "140px", overflowY: "auto" }}>
                        <table className="table table-sm table-bordered table-striped mb-0">
                          <thead
                            className="table-light"
                            style={{
                              position: "sticky",
                              top: 0,
                              zIndex: 5,
                              background: "white",
                            }}
                          >
                            <tr>
                              <th
                                className="text-start"
                                style={{ fontWeight: "bold" }}
                              >
                                Scheme Name
                              </th>
                              <th style={{ fontWeight: "bold" }}>
                                Enrollement
                              </th>
                            </tr>
                          </thead>

                          <tbody className="text-start">
                            {pendingSchemes.map((scheme, index) => (
                              <tr key={scheme.id || index}>
                                <td style={{ fontWeight: 500 }}>
                                  {scheme.name}
                                </td>
                                <td>
                                  <span className="text-danger">Pending</span>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                  <Col md={5}>
                    <div
                      className="p-4 bg-light shadow-lg rounded-4 h-100"
                      style={{ maxHeight: "200px" }}
                    >
                      <h5
                        className="mb-3 text-primary"
                        style={{ fontWeight: "bold" }}
                      >
                        Open Rounds
                      </h5>

                      {/* Scroll only table body */}
                      <div style={{ maxHeight: "140px", overflowY: "auto" }}>
                        <table className="table table-sm table-bordered table-striped mb-0">
                          <thead
                            className="table-light"
                            style={{
                              position: "sticky",
                              top: 0,
                              zIndex: 5,
                              background: "white",
                            }}
                          >
                            <tr>
                              <th className="text-start">Round</th>
                              <th className="text-start">Closing date</th>
                            </tr>
                          </thead>

                          <tbody>
                            {this.state.open_rounds.map((round) => (
                              <tr key={round.id}>
                                <td className="text-start">
                                  {round.scheme_name}
                                </td>
                                <td className="text-start">
                                  {this.formatDate(round.closing_date)}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row className="mt-3 align-items-stretch">
                  <Col md={5}>
                    <div
                      className="p-4 bg-light shadow-lg rounded-4 h-100 d-flex flex-column"
                      style={{ maxHeight: "200px" }}
                    >
                      <h5
                        className="mb-3 text-primary"
                        style={{ fontWeight: "bold" }}
                      >
                        Last Round Report
                      </h5>

                      {/* Scroll only table content */}
                      <div style={{ maxHeight: "140px", overflowY: "auto" }}>
                        <table className="table table-sm table-bordered table-striped mb-0">
                          <thead
                            className="table-light"
                            style={{
                              position: "sticky",
                              top: 0,
                              zIndex: 5,
                              background: "white",
                            }}
                          >
                            <tr>
                              <th className="text-start">Scheme Name</th>
                              <th className="text-start">View Report</th>
                            </tr>
                          </thead>

                          <tbody>
                            {(() => {
                              const rounds = this.state.report_available_rounds;
                              const participantId = this.state.participant_id;

                              if (!rounds || rounds.length === 0) return null;

                              const filteredRounds = rounds.filter(
                                (round) =>
                                  round.status === "Report Available" &&
                                  round.participant_id === participantId,
                              );

                              const groupedByScheme = {};

                              filteredRounds.forEach((round) => {
                                const existing = groupedByScheme[round.scheme];

                                if (
                                  !existing ||
                                  new Date(round.closing_date) >
                                    new Date(existing.closing_date)
                                ) {
                                  groupedByScheme[round.scheme] = round;
                                }
                              });

                              const latestRoundsPerScheme =
                                Object.values(groupedByScheme);

                              return latestRoundsPerScheme.map((round, idx) => (
                                <tr key={idx}>
                                  <td className="text-start">
                                    {round.scheme_name}
                                  </td>
                                  <td className="text-start">
                                    <Tooltip title="View Report">
                                      {round.scheme_type === "Quantitative" ? (
                                        <Link
                                          to={`/${organization_name}/${round.id}/${round.participant_id}/report1_view`}
                                          className="fas fa-file-alt text-primary font-size-18"
                                        />
                                      ) : round.scheme_type ===
                                        "Identification" ? (
                                        <Link
                                          to={`/${organization_name}/${round.id}/${round.participant_id}/micro-report`}
                                          className="fas fa-file-alt text-warning font-size-18"
                                        />
                                      ) : (
                                        <Link
                                          to={`/${organization_name}/${round.id}/${round.participant_id}/qualitative_report_view`}
                                          className="fas fa-file-alt text-success font-size-18"
                                        />
                                      )}
                                    </Tooltip>
                                  </td>
                                </tr>
                              ));
                            })()}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>

                  <Col md={5}>
                    <div
                      className="p-4 bg-light shadow-lg rounded-4 h-100 d-flex flex-column"
                      style={{ maxHeight: "200px" }}
                    >
                      <h5
                        className="mb-3 text-primary"
                        style={{ fontWeight: "bold" }}
                      >
                        Schemes Enrolled
                      </h5>

                      {/* Scroll only the table body */}
                      <div style={{ maxHeight: "140px", overflowY: "auto" }}>
                        <table className="table table-sm table-bordered table-striped mb-0">
                          <thead
                            style={{
                              position: "sticky",
                              top: 0,
                              zIndex: 5,
                              background: "white", // because sticky removes original bg
                            }}
                          >
                            <tr>
                              <th className="text-start">Scheme Name</th>
                              <th className="text-start">Enrollement Date</th>
                              <th className="text-center">Round Issued</th>
                            </tr>
                          </thead>

                          <tbody>
                            {(() => {
                              const schemePaymentsMap = {};
                              this.state.payments.forEach((payment) => {
                                if (!payment.scheme) return;
                                const schemePairs = payment.scheme.split(",");
                                schemePairs.forEach((pair) => {
                                  const [schemeIdStr] = pair.split("-");
                                  const schemeId = parseInt(schemeIdStr.trim());
                                  if (!schemePaymentsMap[schemeId]) {
                                    schemePaymentsMap[schemeId] =
                                      payment.paydate;
                                  }
                                });
                              });

                              if (
                                !this.state.purchased_schemes ||
                                this.state.purchased_schemes.length === 0
                              ) {
                                return (
                                  <tr>
                                    <td
                                      colSpan="3"
                                      className="text-center text-muted"
                                    >
                                      No Purchased Schemes
                                    </td>
                                  </tr>
                                );
                              }

                              return this.state.purchased_schemes.map(
                                (scheme, idx) => {
                                  const roundsIssued = (
                                    this.state.report_available_rounds || []
                                  )
                                    .concat(this.state.open_rounds || [])
                                    .filter(
                                      (round) =>
                                        round.scheme === scheme.scheme_id &&
                                        Number(round.participant_id) ===
                                          Number(this.state.participant_id),
                                    ).length;

                                  return (
                                    <tr key={idx}>
                                      <td className="text-start">
                                        {scheme.scheme_name}
                                      </td>
                                      <td className="text-start">
                                        {schemePaymentsMap[scheme.scheme_id]
                                          ? this.formatDate(
                                              schemePaymentsMap[
                                                scheme.scheme_id
                                              ],
                                            )
                                          : "—"}
                                      </td>
                                      <td className="text-center">
                                        {roundsIssued}
                                      </td>
                                    </tr>
                                  );
                                },
                              );
                            })()}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>

              {/* Right: Notifications */}

              <Col
                md={3}
                className="w-25 p-4 mt-5"
                style={{ marginBottom: "0" }} // ✅ margin from bottom
              >
                <div className="bg-light p-4 shadow-lg h-100 rounded-4 d-flex flex-column">
                  <h5
                    className="text-primary mb-2"
                    style={{ fontWeight: "bold" }}
                  >
                    Notifications
                  </h5>

                  {/* Scrollable list when content overflows */}
                  <div
                    className="flex-grow-1"
                    style={{
                      maxHeight: "360px",
                      overflowY: "auto",
                      paddingRight: "4px", // avoids content shifting under scrollbar
                    }}
                  >
                    <ul className="list-unstyled mb-0">
                      {this.state.notifications
                        .slice()
                        .sort(
                          (a, b) =>
                            new Date(b.date_of_addition) -
                            new Date(a.date_of_addition),
                        )
                        .slice(0, 5)
                        .map((item, idx) => {
                          const dateObj = new Date(item.date_of_addition);
                          const day = String(dateObj.getDate()).padStart(
                            2,
                            "0",
                          );
                          const month = dateObj.toLocaleString("en-US", {
                            month: "short",
                          });
                          const year = String(dateObj.getFullYear()).slice(-2);
                          const formattedDate = `${day}-${month}-${year}`;
                          const formattedTime = dateObj.toLocaleTimeString(
                            "en-IN",
                            {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            },
                          );

                          const isHovered = this.state.hoveredIndex === idx;
                          const isExpanded = this.state.expandedIndex === idx;

                          const shortDescription =
                            item.description.length > 50
                              ? item.description.slice(0, 50)
                              : item.description;

                          return (
                            <li
                              key={idx}
                              className="mb-3"
                              onMouseEnter={() =>
                                this.setState({ hoveredIndex: idx })
                              }
                              onMouseLeave={() =>
                                this.setState({ hoveredIndex: null })
                              }
                              onClick={() =>
                                this.setState({
                                  expandedIndex: isExpanded ? null : idx,
                                })
                              }
                            >
                              <div
                                className="p-3 rounded shadow-sm"
                                style={{
                                  backgroundColor: "#f0f5ff",
                                  fontSize: "0.9rem",
                                  transform: isHovered
                                    ? "scale(1.02)"
                                    : "scale(1)",
                                  transition: "transform 0.2s ease-in-out",
                                  cursor: "pointer",
                                  wordWrap: "break-word",
                                  whiteSpace: "normal",
                                }}
                              >
                                <div className="mb-1 text-primary small fw-semibold">
                                  {formattedDate}{" "}
                                  <span className="mx-1">/</span>{" "}
                                  {formattedTime}
                                </div>

                                <strong
                                  className="d-block text-dark mb-1"
                                  style={{ fontSize: "1rem" }}
                                >
                                  {item.title}
                                </strong>

                                <div className="text-dark">
                                  {isExpanded
                                    ? item.description
                                    : shortDescription}
                                  {!isExpanded && item.description.length > 50 && (
                                    <span
                                      className="ms-1 text-primary"
                                      style={{
                                        textDecoration: "underline",
                                        fontSize: "0.75rem",
                                      }}
                                    >
                                      Read more
                                    </span>
                                  )}
                                </div>
                              </div>
                            </li>
                          );
                        })}
                    </ul>
                  </div>

                  <div className="mt-auto pt-2 border-top text-end">
                    <Link
                      to={`/${organization_name}/newspage`}
                      className="text-primary text-decoration-none"
                    >
                      View All
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>

            {/* </div> */}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

Home.propTypes = {
  match: PropTypes.object,
  className: PropTypes.any,
  gethomedata: PropTypes.func,
  home: PropTypes.array,
};

const mapStateToProps = (state) => ({
  home: state.home.home,
  // organization_name: state.auth.organization_name,
});

const mapDispatchToProps = (dispatch) => ({
  gethomedata: (id) => dispatch(gethomedata(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Home));
